'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixParent = require('../utils/mix-parent.js');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  mixins: [(0, _mixParent.mixParent)('dof-row'), _colmo2.default],
  props: {
    borderRightPadding: {
      type: Number,
      default: 32
    },
    borderBottomPadding: {
      type: Number,
      default: 40
    },
    isShowBorderRight: {
      type: Boolean,
      default: true
    },
    isShowBorderBottom: {
      type: Boolean,
      default: false
    },
    isShowDelta: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ''
    },
    paddingHorizontal: {
      type: {
        type: Number,
        default: 0
      }
    }
  },
  computed: {
    _backgroundColor: function _backgroundColor() {
      if (this.bgColor !== '') return this.bgColor;
      return this._isColmo ? '#303237' : '#fff';
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-numcard-row/index.vue
// module id = 359
// module chunks = 0 1